module.exports = __webpack_public_path__ + "img/menu.e87c2030.png";